import { wrap } from "comlink";
import * as echarts from "echarts";
import { useEffect, useRef, useState } from "react";

import { CalculateWorkerProps } from "./calculate.worker";

export const useEcharts = () => {
  const chartRef = useRef<HTMLDivElement>(null);
  const [chartInstance, setChartInstance] = useState<echarts.ECharts>();
  // 初始化 echarts
  useEffect(() => {
    const instance = echarts?.init(chartRef.current, null);
    setChartInstance(instance);
  }, []);
  return { chartInstance, chartRef };
};

export const useWorker = <T = CalculateWorkerProps>() => {
  const workerRef = useRef<ReturnType<typeof wrap<T>>>(undefined);
  useEffect(() => {
    const work = new Worker(new URL("./calculate.worker.ts", import.meta.url));
    workerRef.current = wrap<T>(work);
  }, []);
  return workerRef.current;
};
